import * as React from 'react';
import { PageTitle } from 'components/title/title';
import { GTMManager } from 'components/gtm';
import { BuyProcessForm } from '../../components/buy-process-form';
import { MobileWarn } from '../../components/app/components/mobile-warn/mobile-warn';

export const BuyProcessPage = () => (
  <React.Fragment>
    <GTMManager />
    <PageTitle title="Beställ Aktiebolag - Snabbt, Enkelt och Steg för Steg | Citadellet Bolagsservice AB" />
    <MobileWarn />

    <BuyProcessForm />
  </React.Fragment>
);

export default BuyProcessPage;
